import React, { useEffect } from "react";
import { TemplateInterface } from "../../../../store/roblox/templatesSlice";

import {Button, Checkbox, Form, Input, InputNumber, Radio, Switch} from "antd";
import FileDropzone from "../../../../componets/FileDropzone";
import ThumbnailGenerator from "./_ThumbnailGenerator";

interface propsInterface {
  params?: TemplateInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();
  const [templatePreview, setTemplatePreview] = React.useState<string | undefined>(params?.thumbnail_url);
  const typeIdValue   = Form.useWatch('type_id', form);

  useEffect(() => {
    form.resetFields();
    setTemplatePreview(params?.thumbnail_url);
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='target_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={templatePreview} />
        <FileDropzone name='texture' label='Texture' preview={params?.texture_url} />
      </div>

      {
        typeIdValue !== 4 &&
          <ThumbnailGenerator
            form={form}
            imgUrl={params?.texture_url}
            setTemplatePreview={setTemplatePreview}
          />
      }

      <Form.Item label="Type" name='type_id'>
        <Radio.Group>
          <Radio value={0}>Pants</Radio>
          <Radio value={1}>Shirt</Radio>
          <Radio value={2}>T-Shirt</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item label="Premium" name='premium' valuePropName='checked'>
        <Switch />
      </Form.Item>

      <Form.Item name='coins' label="Coins">
        <InputNumber min={0} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
